var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66666V10L11.6667 11.6667",
    stroke: "#DE6161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5415 9.16833C2.72825 7.33505 3.58339 5.63468 4.94378 4.39164C6.30417 3.1486 8.07458 2.4499 9.91723 2.42886C11.7599 2.40781 13.5458 3.06589 14.9342 4.27753C16.3227 5.48917 17.2164 7.16956 17.445 8.99811C17.6735 10.8266 17.2209 12.6753 16.1735 14.1915C15.126 15.7076 13.557 16.785 11.7659 17.2182C9.97477 17.6514 8.08685 17.41 6.46233 16.5401C4.83782 15.6701 3.59044 14.2326 2.95817 12.5017",
    stroke: "#DE6161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5415 16.6683V12.5017H6.70817",
    stroke: "#DE6161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon2);
export default __webpack_public_path__ + "static/media/clockIcon2.52a1445672b85a1276e083e14a20d495.svg";
export { ForwardRef as ReactComponent };